// Don't use `rem` units for anything since existing CSS `font-size` affects all rem units
// https://github.com/am-systems/am-web-properties/blob/c1d44502a5babfe955a7f7462eba23658a73bbe3/public/thecreditreview/css/top-services/media-query.css#L22-L25.
// Existing `rem` units are migrated values from old styles to avoid breaking layouts.
export const getStyles = (companyIndex) => ({
	featuredCompanyHeader: {
		wrapper:
			"tw:bg-[#EDF4FE] tw:text-center tw:text-balance tw:rounded-t-[3px] tw:py-[8px] tw:px-[20px]",
		contentWrapper:
			"tw:text-[#333641] tw:font-semibold tw:leading-[24px] tw:text-[16px] tw:tracking-[-0.16px]",
	},
	serviceFlag: {
		wrapper:
			"tw:absolute tw:top-[16px] tw:left-[-8px] tw:flex tw:desktop:top-[24px]",
		flag: "tw:w-[28px] tw:h-[28px] tw:bg-[#0D8AE3] tw:flex tw:items-center tw:justify-center tw:rounded-[3px]",
		number:
			"tw:text-white tw:text-[12px] tw:m-0 tw:pt-[2px] tw:font-semibold tw:leading-[16px]",
		text: `tw:relative tw:ml-[2px] tw:h-[28px] tw:rounded-[3px] tw:pl-[8px] tw:pt-[7px] tw:pb-[5px] tw:flex tw:items-center tw:justify-center ${
			companyIndex === 0 ? "tw:bg-[#0D8AE3]" : "tw:bg-[#333742]"
		} tw:text-white tw:text-[12px] tw:font-semibold tw:leading-[16px] tw:after:relative tw:after:left-[6px] tw:after:-top-px tw:after:w-[16px] tw:after:h-[28px] tw:after:[border-right:10px_solid_white] ${
			companyIndex === 0
				? "tw:after:[border-top:14px_solid_#0D8AE3] tw:after:[border-bottom:14px_solid_#0D8AE3]"
				: "tw:after:[border-top:14px_solid_#333742] tw:after:[border-bottom:14px_solid_#333742]"
		}`,
	},
	companyLogo: {
		picture: "tw:max-w-[200px]",
		image: "tw:max-w-full",
	},
	rating: {
		wrapper:
			"tw:flex tw:items-center tw:gap-[6px] tw:rounded-full tw:bg-white tw:px-[12px] tw:py-[8px] tw:shadow-[0px_5px_32px_0px_rgba(0,0,0,0.04),0px_10px_64px_0px_rgba(50,50,93,0.06)] tw:xs:px-[20px] tw:xs:py-[12px] tw:xs:gap-[8px]",
		score:
			"tw:text-[28px] tw:font-bold tw:leading-[28px] tw:font-graphikWeb tw:tracking-[-1.12px] tw:text-[#333742] tw:m-0 tw:xs:text-[32px] tw:xs:leading-[32px] tw:xs:tracking-[-1.28px]",
		stars: "tw:flex tw:flex-col tw:gap-[8px]",
		starColor: "tw:text-[#059669]",
		starSize: "tw:text-[14px] tw:xs:text-[16px]",
		count:
			"tw:ml-[2px] tw:text-[12px] tw:font-semibold tw:leading-[12px] tw:text-[#333742] tw:mr-0 tw:my-0 tw:xs:text-[16px] tw:xs:leading-[16px]",
	},
	columnInformation: {
		wrapper:
			"tw:grid tw:gap-[8px] tw:p-[16px] tw:rounded-[3px] tw:border-2 tw:border-solid tw:border-[#F0F0F0] tw:bg-white tw:desktop:flex tw:desktop:justify-between tw:desktop:items-center tw:xs:[&_>_:not(:last-child)]:after:w-[2px] tw:xs:[&_>_:not(:last-child)]:after:h-full tw:xs:[&_>_:not(:last-child)]:after:bg-[#F0F0F0] tw:xs:[&_>_:not(:last-child)]:after:absolute tw:xs:[&_>_:not(:last-child)]:after:right-[-5px] tw:xs:[&_>_:not(:last-child)]:after:top-0 tw:desktop:[&_>_:not(:last-child)]:after:right-[-24px]",
		columnWrapper:
			"tw:relative tw:flex tw:items-center tw:justify-center tw:gap-[8px] tw:xs2:gap-[12px] tw:text-center tw:lg2:text-left",
		column: "",
		label:
			"tw:mb-[8px] tw:font-montserrat tw:text-[12px] tw:text-[#71777A] tw:uppercase tw:font-semibold tw:leading-[16px] tw:max-w-[95px] tw:lg2:max-w-none",
		value:
			"tw:text-[14px] tw:font-graphikWeb tw:leading-[16px] tw:font-semibold tw:text-[#232227]",
	},
	mobileSocialProof: {
		wrapper: "tw:flex tw:mt-[8px] tw:justify-center tw:desktop:hidden",
		contentWrapper: "tw:flex tw:items-center tw:gap-[8px]",
		contentIcon: "tw:text-[#0D8AE3] tw:text-[20px]",
		content:
			"tw:leading-[12px] tw:font-semibold tw:text-[12px] tw:text-[#232227] tw:pt-[4px] tw:m-0",
	},
	benefitsList: {
		wrapper: "tw:w-full",
		list: "tw:m-0 tw:max-w-full tw:flex tw:flex-col tw:xs2:w-[500px] tw:desktop:w-full",
		listItem:
			"tw:mb-[8px] tw:text-pretty tw:mx-0 tw:pl-[25px] tw:text-[#48484B] tw:font-semibold tw:text-[16px] tw:leading-[24px] tw:bg-[url(/public/react-images/common/iconTick.svg)] tw:bg-no-repeat tw:bg-position-[left_top_5px] tw:last:mb-0",
		expandButton:
			"tw:w-full tw:flex tw:cursor-pointer tw:items-center tw:border-0 tw:bg-transparent tw:py-0 tw:pl-[25px] tw:text-[#0D8AE3] tw:md:mt-[20px]",
		expandBenefitsContent:
			"tw:text-[16px] tw:font-semibold tw:leading-[24px] tw:pt-[2px]",
		expandButtonIcon: "tw:ml-[8px] tw:text-[24px] tw:rotate-90",
	},
	socialProof: {
		wrapper:
			"tw:hidden tw:relative tw:desktop:flex tw:w-full tw:mb-[12px] tw:justify-center tw:border-[rgba(88,102,126,0.10)] tw:desktop:max-w-fit tw:desktop:bg-white tw:desktop:rounded-lg tw:desktop:p-2 tw:desktop:filter-[drop-shadow(0px_0px_1px_rgba(88,102,126,0.48))_drop-shadow(0px_0px_24px_rgba(88,102,126,0.10))] tw:desktop:after:absolute tw:desktop:after:right-[calc(50%-6px)] tw:desktop:after:w-2.5 tw:desktop:after:h-2.5 tw:desktop:after:translate-x-0 tw:desktop:after:-translate-y-2/4 tw:desktop:after:rotate-45 tw:desktop:after:bg-white tw:desktop:after:overflow-hidden tw:desktop:after:pointer-events-none tw:desktop:after:bottom-[-8px]",
		contentWrapper:
			"tw:flex tw:flex-row tw:justify-center tw:items-center tw:gap-2",
		contentIcon: "tw:text-[#0D8AE3] tw:text-[20px] tw:md:text-[32px]",
		content:
			"tw:leading-[12px] tw:font-semibold tw:text-[12px] tw:text-[#232227] tw:pt-[4px] tw:md:leading-[16px] tw:m-0 tw:desktop:max-w-[110px] ",
	},
	reviewLink: {
		wrapper:
			"tw:mt-[16px] tw:ml-[-8px] tw:flex tw:cursor-pointer tw:items-center tw:gap-[8px] tw:text-[#0D8AE3] tw:hover:underline tw:underline-offset-8 tw:hover:underline-offset-4 tw:transition-all tw:desktop:ml-0",
		text: "tw:text-[16px] tw:pt-[2px] tw:font-semibold tw:leading-[22px] tw:desktop:leading-[24px]",
	},
});
